export const CATEGORIES = {
  get: "/categories",
};
